<template>
  <div>
    <transition-group name="list" tag="span">
    <div v-for="(source, index) in selectedSources" :key="source.sourceName+index" class="wrapper">
      <div class="source">
        <span class="index">חשבון {{ index + 1 }}</span>
        <img :src="require(`@/assets/bank-logos/${source.logoFile}`)" class="logo">
        <div class="remove-container">
          <img class="remove" v-on:click="removeSource(index)" :src="require('@/assets/icons/close.svg')">
        </div>
      </div>
    </div>
    </transition-group>
  </div>
</template>

<script>

export default {
  name: 'SelectedSources',
  props: [
    'selectedSources',
    'removeSource',
  ],
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  .wrapper {
    max-height: 68px;
    border-bottom: solid 1px $riseup_gray_0;
  }
  .list-enter-active {
    transition: opacity 0.5s linear 0.5s, max-height 1s;
  }
  .list-leave-active {
    transition: opacity 0.2s ease-out, max-height 1s;
  }
  .list-enter, .list-leave-to {
    max-height: 0;
    opacity: 0;
  }
  .source {
    padding: 0 30px 0 5px;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .index {
      font-family: SimplerPro;
      font-size: 22px;
    }
    .logo {
      height: 40px;
    }
    .remove-container {
      position: relative;
      height: 100%;
      .remove {
        position: absolute;
        top: 3px;
        left: -2px;
        width: 15px;
        cursor: pointer;
      }
    }
  }

</style>
